import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rd-carousel-data',
  template: `<div class="carouselDataWrapper" *ngIf="displayed">
  <ng-content></ng-content>
</div>
`,
  styles: [`.carouselDataWrapper{width:100%;overflow:hidden;height:100%;z-index:1}.carouselDataWrapper::ng-deep *{position:absolute;width:100%;height:100%;-o-object-fit:contain;object-fit:contain}:host{position:absolute;width:100%;height:100%}`]
})
export class RDCarouselDataComponent implements OnInit {

  @Output() displayChange: EventEmitter<any> = new EventEmitter();

  public displayed = false;

  constructor() { }

  ngOnInit() {
  }

}
